import {createSlice} from '@reduxjs/toolkit';
import moment from 'moment';

interface DailyShiftsInitialState {
  fromAndToFilter?: {
    to: string;
    from: string;
  };
}

const initialState: DailyShiftsInitialState = {
  fromAndToFilter: {
    from: moment(new Date()?.setHours(0, 0, 0, 0)).toISOString(),
    to: moment(new Date()?.setHours(23, 59, 59, 59)).toISOString(),
  },
};

const dailyShiftsSlice = createSlice({
  name: 'dailyShifts',
  initialState: initialState,
  reducers: {
    setFromAndToFilter: (state, action) => {
      state.fromAndToFilter = action.payload;
    },
  },
});

export const {setFromAndToFilter} = dailyShiftsSlice.actions;

export default dailyShiftsSlice.reducer;
